import '../style/Pricing.css';
import { Link } from 'react-router-dom';

const Pricing = () => {
  return (
    <>
      <title>REM Pricing</title>
      <meta
        name='description'
        content='Explore our products and pricing options.'
      />
      <div className='pricing-container'>
        <h1>Pricing</h1>

        <div className='pricing-cards-container'>
          <Link to='/contact' className='pricing-card approved'>
            <h2>General Consultation</h2>
            <h4>Custom rates</h4>
            <p>
              Tenancy setup, accounts registrations, document preparation, and
              more!
            </p>
          </Link>
          <div className='pricing-card coming-soon'>
            <h2>Coming Soon</h2>
          </div>
          <div className='pricing-card coming-soon'>
            <h2>Coming Soon</h2>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pricing;
